import { token } from '@/styled-system/tokens';

// Sourced from the Constellation/Panda breakpoint scale so JS-side media
// queries stay in lockstep with `md:` / `lg:` / `xl:` Panda conditions.
// Pure constants only — kept server-safe so RSCs can read media-query strings
// without dragging in client-only hooks. `useIsDesktop` lives in
// `src/lib/hooks/ui/useIsDesktop.ts`.
export const SM = token('breakpoints.sm');
export const MD = token('breakpoints.md');
export const LG = token('breakpoints.lg');
export const XL = token('breakpoints.xl');

export const MIN_SM = `(min-width: ${SM})`;
export const MIN_MD = `(min-width: ${MD})`;
export const MIN_LG = `(min-width: ${LG})`;
export const MIN_XL = `(min-width: ${XL})`;
export const BELOW_LG = `not all and (min-width: ${LG})`;
